module.exports = __webpack_public_path__ + "static/media/17_l_kusti_0_61.48.85c60b42.png";